import {
  StorageMountsAdminPage as PlatformStorageMountsAdminPage,
  type MentionPeerLinkApi,
  type StorageMountsAdminApi,
  type StorageMountsAdminCopy
} from '@jarvis/platform-ui';
import {
  createMount,
  deleteMount,
  getMentionScope,
  getMount,
  listMounts,
  listPeerCandidates,
  listRoles,
  searchGroups,
  setMentionPeer,
  testMount,
  testMountConnection,
  updateMount
} from '../../../api/storageMountsAdmin';

const storageMountsApi: StorageMountsAdminApi = {
  listMounts,
  getMount,
  createMount,
  updateMount,
  deleteMount,
  testMount,
  testMountConnection,
  listRoles,
  searchGroups
};

const webOpsCopy: StorageMountsAdminCopy = {
  apiSiteLabel: 'WebOps',
  pageSubtitle:
    'Configure SMB shares and S3/MinIO buckets shown in the file browser. Assign role and Entra group bindings to control per-mount visibility.',
  noBindingsHint: 'No bindings — only ItSysAdmin and global override groups can access this mount.',
  accessGrantHint:
    'Grant a role (+ optional Entra group) read or write access. ItSysAdmin always has full access to all mounts.',
  adminRoleLabel: 'ItSysAdmin'
};

const mentionPeerLink: MentionPeerLinkApi = {
  peerSiteLabel: 'Client Portal',
  listPeerCandidates: () => listPeerCandidates(),
  getMentionScope,
  setMentionPeer
};

export function StorageMountsAdminPage() {
  return (
    <PlatformStorageMountsAdminPage
      api={storageMountsApi}
      copy={webOpsCopy}
      stateStorageKey="webopsui:storage-mounts-grid"
      mentionPeerLink={mentionPeerLink}
    />
  );
}
